import { LANGUAGE_CODE } from "./constants";
import { notification } from "antd";

const getNotificationKey = (
  type: "error" | "success" | "info",
  message: string,
  description?: string,
) => `${type}-${message}-${description ?? ""}`;

export const errorNotification = (message: string, description?: string) => {
  return notification["error"]({
    key: getNotificationKey("error", message, description),
    message: message,
    description: description ?? "",
    style: {
      direction: localStorage.getItem(LANGUAGE_CODE) === "ar" ? "rtl" : "ltr",
    },
    placement:
      localStorage.getItem(LANGUAGE_CODE) === "ar"
        ? "bottomLeft"
        : "bottomRight",
    duration: 2,
  });
};
export const successNotification = (message: string, description?: string) => {
  return notification["success"]({
    key: getNotificationKey("success", message, description),
    message: message,
    description: description ?? "",
    style: {
      direction: localStorage.getItem(LANGUAGE_CODE) === "ar" ? "rtl" : "ltr",
    },
    placement:
      localStorage.getItem(LANGUAGE_CODE) === "ar"
        ? "bottomLeft"
        : "bottomRight",
    duration: 2,
  });
};

export const btnNotification = (
  message: string,
  description?: string,
  buttonText?: any,
) => {
  return notification["info"]({
    key: getNotificationKey("info", message, description),
    message: message,
    description: description ?? "",
    style: {
      direction: localStorage.getItem(LANGUAGE_CODE) === "ar" ? "rtl" : "ltr",
    },
    placement:
      localStorage.getItem(LANGUAGE_CODE) === "ar" ? "topLeft" : "topRight",
    btn: buttonText,
  });
};
